import React from 'react'

import {
  AlignItems,
  Body2,
  Bold,
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
  Icon,
  IconVariant,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const ConfirmationBanner = withCitrusTheme(Box, () => ({
  borderRadius: '8px',
}))

type CopyConfirmationProps = {
  credit: string
  isBoost?: boolean
}

export const CopyConfirmation = ({ credit, isBoost = false }: CopyConfirmationProps) => (
  <ConfirmationBanner
    display={Display.Flex}
    alignItems={AlignItems.FlexStart}
    gap={2}
    bg={isBoost ? Color.Success_900 : Color.Success_50}
    borderColor={isBoost ? Color.Success_50 : Color.Success_900}
    borderStyle={BorderStyle.Solid}
    borderWidth={0.5}
    paddingV={4}
    paddingH={4}
    role="status"
    data-testid="rafLinkCopyConfirmation"
  >
    <Box color={isBoost ? Color.Success_50 : Color.Success_900} display={Display.Flex}>
      <Icon name="success" size={6} variant={IconVariant.Inherit} />
    </Box>
    <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
      <Body2 size={4} color={isBoost ? Color.Success_50 : Color.Success_900}>
        <Bold>Link copied, now send it to a friend</Bold>
      </Body2>
      <Body2 size={4} color={isBoost ? Color.White : Color.ColdGrey_800}>
        You&apos;ll get {credit} credit once they get their first box.
      </Body2>
    </Box>
  </ConfirmationBanner>
)
